import $ from 'jquery';
import React from 'react';
import VastInspector from './vastInspector/VastInspector';
import PlacementDataRedux from '../../containers/pluginSettings/PlacementData';
import AdRulesRedux from '../../containers/pluginSettings/AdRules';
import ConfigurationRedux from '../../containers/pluginSettings/Configuration';
import OtherSettingsRedux from '../../containers/pluginSettings/OtherSettings';
import ExportPopUpRedux from '../../containers/sections/ExportPopUp.js';
import ImportPopUpRedux from '../../containers/sections/ImportPopUp.js';
import LogsPanelRedux from '../../containers/logsPanel/LogsPanel.js';
import { isMobile, sections } from '../../constants/Constants';
import { SP_BTN_LABELS, VF_INIT_AREA } from '../../constants/Labels';
import { isUrl, setLocalStorage, updateSize } from '../../helpers/tools';
import ShareLinkPopUpRedux from '../../containers/sections/ShareLinkPopUp';
import DropdownRedux from '../../containers/sections/Dropdown';

class SectionsPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      key: Math.random(),
    };
  }

  componentDidMount() {
    updateSize();
    globalThis.addEventListener('resize', updateSize.bind(this));
  }

  /**
   * Method to restore popup configuration when popup is reopenned before timeout ending
   * @param {number} timeoutId timeout id
   * @param {string} copyButtonId copy button id
   */
  restorePopUpConfiguration = (timeoutId, buttonId) => {
    clearTimeout(timeoutId);
    const text =
      buttonId === '#copy-settings-btn' || buttonId === '#copy-link-btn' ? 'Copy' : 'Apply';
    $(buttonId).text(text);
  };

  toggleElement = (event, targetSelector) => {
    let targetElement = $(event.target).parent().parent().find(targetSelector),
      display = $(targetElement).css('display') === 'none' ? 'block' : 'none';

    $(targetElement).css('display', display);
    $(event.target).toggleClass('open');

    // show more button
    if (targetSelector === '.more') {
      $(event.target).html(
        display === 'none' ? 'Show more options <span>▼</span>' : 'Show less options <span>▲</span>'
      );
    }

    // settings section
    if (event.target.classList.contains('pluginSectionsTitle')) {
      $(event.target).closest('.pluginSettingsSection').toggleClass('open');
    }
    updateSize();
    return false;
  };
  /**
   * Method to trigger the validation of the configuration after import settings
   */
  forceValidationWithBlurEvent = () => {
    $('.settingsInputs .inputsRow input').trigger('blur', [true]);
  };

  /**
   * Handler for click on Test button
   */
  onClick = () => {
    if (!this.isVastSourceValid()) {
      return;
    }
    this.forceValidationWithBlurEvent();

    this.props.onClick();
    this.openTab(sections.OUTPUT);
  };

  /**
   * Check if vast source has some value different than empty and default
   * @returns Boolean
   */
  isVastSourceValid = () => {
    let valid = true;
    if (
      this.props.activeSection === 0 &&
      (!this.props.vastSource.length || this.props.vastSource === VF_INIT_AREA)
    ) {
      valid = false;
    }
    return valid;
  };

  /**
   * Handler for click on '...' button
   */
  showDropdown = () => {
    if (this.props.activeSection !== 1) return;

    const dropdown = $('#dropdown'),
      dropdownClass = 'dropdown-visible',
      closeDropdown = (event, triggerer) => {
        if (!triggerer && !dropdown.find(event.target).length && dropdown[0] !== event.target) {
          $(document).off(isMobile ? 'touchend' : 'mousedown', closeDropdown);
          dropdown.removeClass(dropdownClass);
        }
      };

    dropdown.addClass(dropdownClass);

    $(document).on(isMobile ? 'touchend' : 'mousedown', closeDropdown);
  };

  /**
   * Handler for click on 'Share Link' button
   */
  onShareButtonClick = () => {
    switch (this.props.activeSection) {
      case sections.VAST_INSPECTOR:
        if (isUrl(this.props.vastSource)) {
          this.props.updateVastConfigurationUrl(
            `${globalThis.location.origin}?vtag=${encodeURIComponent(this.props.vastSource.trim())}`
          );
        }
        break;
      case sections.PLUGIN_SETTINGS:
        this.props.postConfiguration();
        break;
      default:
        break;
    }
  };

  /**
   * Method to change the sub tab
   * @param {Number} subTabIndex
   */
  openSubTab = subTabIndex => {
    if (this.props.subTab === subTabIndex) {
      return;
    }

    setLocalStorage('subTab', subTabIndex);
    this.props.updateSubTab(subTabIndex);

    //To trigger errors on the previous subTab
    $('.settingsInputs .inputsRow input').trigger('blur', [true]);

    setTimeout(() => {
      //To trigger errors on the current subTab
      $('.settingsInputs .inputsRow input').trigger('blur', [true]);
      updateSize();
    }, 100);
  };

  /**
   * Method to change the tab
   * @param {Number} activeTabIndex
   */
  openTab = activeTabIndex => {
    if (this.props.activeSection === activeTabIndex) {
      return;
    }

    if (activeTabIndex !== 2) {
      setLocalStorage('activeSection', activeTabIndex);
    }
    this.props.updateActiveSection(activeTabIndex);

    setTimeout(() => {
      //To trigger errors on the current subTab
      if (activeTabIndex === 1) {
        $('.settingsInputs .inputsRow input').trigger('blur', ['true']);
      }

      updateSize();
    }, 100);
  };

  /**
   * Method to rerender the input panel
   */
  resetData = () => {
    if (this.props.activeSection === 2) {
      return;
    }
    this.props.resetData();

    this.setState({
      key: Math.random(),
    });
  };

  render() {
    let tabs = [
      {
        component: <VastInspector />,
      },
      {
        subTabs: [
          {
            component: <PlacementDataRedux toggleElement={this.toggleElement} />,
            name: 'Placement Data',
            valid: this.props.validationStates['adData'],
          },
          {
            component: <AdRulesRedux />,
            name: 'Ad rules settings',
            valid: this.props.validationStates['adRules'],
          },
          {
            component: <ConfigurationRedux toggleElement={this.toggleElement} />,
            name: 'Configuration',
            valid: this.props.validationStates['configuration'],
          },
          {
            component: <OtherSettingsRedux />,
            name: 'Other settings',
            valid: this.props.validationStates['other'],
          },
        ],
      },
      {
        component: <LogsPanelRedux />,
      },
    ];

    return (
      <div className="inputPanel" key={this.state.key}>
        <div className="sectionsPanel">
          <div id="tabs" className="tab">
            {tabs.map((item, index) => (
              <button
                type="button"
                className={'tablink' + (index === this.props.activeSection ? ' active' : '')}
                id={'tablink' + index}
                key={'tablink' + index}
                onClick={() => this.openTab(index)}
              >
                {SP_BTN_LABELS[index]}
              </button>
            ))}
          </div>
          {tabs[this.props.activeSection].subTabs && (
            <div id="subTabs" className="tab">
              {tabs[this.props.activeSection].subTabs.map((item, index) => (
                <div
                  id={'subTab' + index}
                  key={'subTab' + index + '_' + item.valid}
                  className={
                    'subTab' +
                    (index === this.props.subTab ? ' active' : '') +
                    (item.valid ? '' : ' invalid')
                  }
                  onClick={() => this.openSubTab(index)}
                >
                  {item.name}
                </div>
              ))}
            </div>
          )}
          <div id="section">
            {tabs[this.props.activeSection].component ||
              tabs[this.props.activeSection].subTabs[this.props.subTab].component}
          </div>
        </div>
        <div className="btnPanel">
          <div>
            <button
              type="button"
              className={
                this.props.activeSection === 2 || !this.isVastSourceValid()
                  ? 'btnGeneral primaryBtn disabled'
                  : 'btnGeneral primaryBtn'
              }
              id="button-apply"
              onClick={() => this.onClick()}
            >
              Start Test
            </button>
            <button
              type="button"
              className={
                this.props.activeSection === 2 ||
                (this.props.activeSection === 0 && !isUrl(this.props.vastSource))
                  ? 'btnGeneral disabled'
                  : 'btnGeneral'
              }
              id="button-share"
              onClick={() => this.onShareButtonClick()}
            >
              Share Link
            </button>
            <span
              className={this.props.activeSection === 2 ? 'btnSeparator disabled' : 'btnSeparator'}
            />
            <button
              type="button"
              className={this.props.activeSection === 2 ? 'btnGeneral disabled' : 'btnGeneral'}
              id="reset-data"
              onClick={() => this.resetData()}
            >
              Reset Settings
            </button>
            {this.props.activeSection !== 0 && (
              <div id="moreOptions">
                <button
                  type="button"
                  className={this.props.activeSection === 2 ? 'btnGeneral disabled' : 'btnGeneral'}
                  onClick={() => this.showDropdown()}
                >
                  ...
                </button>
                <DropdownRedux />
              </div>
            )}
          </div>
        </div>
        <div id="export-import-pop-up" className="export-import-pop-up popUp">
          <ExportPopUpRedux restorePopUpConfiguration={this.restorePopUpConfiguration} />
          <ImportPopUpRedux
            restorePopUpConfiguration={this.restorePopUpConfiguration}
            callback={this.forceValidationWithBlurEvent}
          />
        </div>
        <div id="share-link-pop-up" className="share-link-pop-up popUp">
          <ShareLinkPopUpRedux restorePopUpConfiguration={this.restorePopUpConfiguration} />
        </div>
      </div>
    );
  }
}

export default SectionsPanel;
